import React from "react";

const BookingInfo = ({
  CheckIn,
  CheckOut,
  RoomsData,
  SelectedCustomer,
  SelectedHotel,
  setCheckIn,
  setCheckOut,
  FormData,
  finalAmount,
}) => {
  const nights =
    CheckIn && CheckOut
      ? (new Date(CheckOut) - new Date(CheckIn)) / (1000 * 60 * 60 * 24)
      : 0;
  const grandTotal =
    RoomsData?.length > 0
      ? RoomsData.reduce((acc, room) => {
          const price = room?.actualPrice || 0;
          const discount = room?.discount || 0;
          const tax = room?.tax || 0;

          const discountedPrice = price - (price * discount) / 100;
          const taxAmount = (discountedPrice * tax) / 100;
          const total = discountedPrice + taxAmount;

          return acc + total * nights;
        }, 0)
      : 0;

  return (
    <div className="space-y-3">
      <div className="py-5 px-4 bg-white">
        <div className="flex justify-between items-start">
          <div className="space-y-3">
            <p className="text-sm">
              <strong>Invoice:</strong> {FormData.invoiceId}
            </p>
            <p className="text-sm">
              <strong>TransactionId:</strong> {FormData.transactionId || ""}
            </p>
            <div className="space-y-2 p-3 border border-dashed border-orange-600 rounded-lg">
              <div className="flex justify-start items-center gap-3">
                <p className="text-sm text-nowrap">
                  <strong>CheckIn:</strong>
                </p>
                <input
                  type="date"
                  className="w-full border rounded-md focus:outline-none px-2 py-1"
                  onChange={(e) => setCheckIn(e.target.value)}
                  value={CheckIn}
                />
              </div>
              <div className="flex justify-start items-center gap-3">
                <p className="text-sm text-nowrap">
                  <strong>CheckIn:</strong>
                </p>
                <input
                  type="date"
                  className="w-full border rounded-md focus:outline-none px-2 py-1"
                  onChange={(e) => setCheckOut(e.target.value)}
                  value={CheckOut}
                />
              </div>
            </div>
          </div>
          <div className="space-y-3">
            {SelectedCustomer && (
              <>
                <p className="text-sm">
                  <strong>Customer Name:</strong>{" "}
                  {SelectedCustomer?.fullName || ""}
                </p>
                <p className="text-sm">
                  <strong>Customer Phone Number:</strong>{" "}
                  {SelectedCustomer?.phoneNumber || ""}
                </p>
                <p className="text-sm">
                  <strong>Customer Email:</strong>{" "}
                  {SelectedCustomer?.email || ""}
                </p>
              </>
            )}
          </div>
        </div>
        {SelectedHotel && (
          <div className="flex justify-center items-center gap-3">
            <div>
              <img
                src={SelectedHotel.hotelLogo}
                className="w-20 h-10 object-contain"
                alt=""
              />
            </div>
            <div>
              <p className="text-xl font-semibold uppercase">
                {SelectedHotel.hotelName || ""} | {nights}/nights
              </p>
            </div>
          </div>
        )}
      </div>
      <div>
        <div>
          <div className="py-3 w-full overflow-x-auto">
            <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Room
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Actual Price (BDT)
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Discounted Price (BDT)
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Service Charge (BDT)
                  </th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Total (BDT)
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200">
                {RoomsData?.length > 0 ? (
                  RoomsData.map((room) => {
                    const price = room?.actualPrice || 0;
                    const discount = room?.discount || 0;
                    const tax = room?.tax || 0;

                    const discountedPrice = price - (price * discount) / 100;
                    const taxAmount = (discountedPrice * tax) / 100;
                    const total = discountedPrice + taxAmount;

                    return (
                      <tr key={room.id} className="hover:bg-gray-50">
                        <td className="px-4 py-3 text-sm text-gray-700">
                          {room.roomName}
                        </td>

                        <td className="px-4 py-3 text-sm">
                          {price.toFixed(0) * nights}
                        </td>

                        <td className="px-4 py-3 text-sm text-gray-700">
                          {discountedPrice.toFixed(0) * nights} ({room.discount}
                          %)
                        </td>

                        <td className="px-4 py-3 text-sm">
                          {room.serviceChargeAmount.toFixed(0) * nights} (
                          {room.serviceCharge}%)
                        </td>

                        <td className="px-4 py-3 text-sm text-start">
                          {total.toFixed(0) * nights}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-4 text-gray-500">
                      No room selected
                    </td>
                  </tr>
                )}
                <tr>
                  <td
                    colSpan="4"
                    className="px-4 py-3 text-sm text-end font-semibold"
                  >
                    Total Amount
                  </td>
                  <td className="px-4 py-3 text-sm text-start font-semibold">
                    {grandTotal.toFixed(0) || 0}
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan="4"
                    className="px-4 py-3 text-sm text-end font-semibold"
                  >
                    Total Service Charge
                  </td>
                  <td className="px-4 py-3 text-sm text-start font-semibold">
                    {FormData?.taxAmount.toFixed(0) || 0}
                  </td>
                </tr>
                <tr className="bg-blue-100">
                  <td
                    colSpan="4"
                    className="px-4 py-3 text-sm text-end font-semibold"
                  >
                    Grand Total
                  </td>
                  <td className="px-4 py-3 text-sm text-start font-semibold">
                    {((grandTotal || 0) + (FormData?.taxAmount || 0)).toFixed(
                      0,
                    )}
                  </td>
                </tr>
                <tr className="bg-green-100">
                  <td
                    colSpan="4"
                    className="px-4 py-3 text-sm text-end font-semibold"
                  >
                    Advance Amount ({SelectedHotel?.advancePayment || 0}%)
                  </td>
                  <td className="px-4 py-3 text-sm text-start font-semibold">
                    {!isNaN(finalAmount) ? finalAmount.toFixed(0) : 0}
                  </td>
                </tr>
                <tr>
                  <td
                    colSpan="4"
                    className="px-4 py-3 text-sm text-end font-semibold"
                  >
                    Hotel Payable
                  </td>
                  <td className="px-4 py-3 text-sm text-start font-semibold">
                    {((grandTotal || 0) - (finalAmount || 0)).toFixed(0)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingInfo;
